import { render, staticRenderFns } from "./GeneralInformationEligibility.vue?vue&type=template&id=7672f1ee&scoped=true"
import script from "./GeneralInformationEligibility.vue?vue&type=script&lang=js"
export * from "./GeneralInformationEligibility.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=7672f1ee&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7672f1ee",
  null
  
)

export default component.exports